import { BrowserRouter, Routes, Route } from 'react-router-dom';
import React, { Suspense } from 'react';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import config from './config';
import PageNotFound from './Components/Pages/Pagenotfound';
import Home from './Components/Pages/Home';
import Home2 from './Components/Pages/Home2';
import Presale from './Components/Pages/Presale/Home';
import Presalesecond from './Components/Pages/Presalesecond/Home';
import Aboutus from './Components/Pages/Aboutus';
import Contactus from './Components/Pages/Contactus';
import Privacypolicy from './Components/Pages/Privacypolicy';
import UserLogin from './Components/Auth/Login';
import Emailconfirmation from './Components/Auth/Emailconfirmation';
import Walletform from './Components/Auth/Walletform';
import Selectwalletform from './Components/Auth/Selectwalletform';
import Scanwallet from './Components/Auth/Scanwallet';
import Faq from './Components/Pages/Faq';

// -------------------
import Dashboard from './Components/Pages/Presale/Dashboard';
import Swap from './Components/Dashboard/Swap';
import Liquiditypool from './Components/Dashboard/Liquiditypool';
// import Addliquidity from './Components/Dashboard/Liquiditypool/Addliquidity';
// import Removeliquidity from './Components/Dashboard/Liquiditypool/Removeliquidity';
import UserSignup from './Components/Auth/Signup';
import Simplestaking from './Components/Dashboard/Staking/Simplestaking';
import TransactionHistory from './Components/Dashboard/TransactionHistory/index';

import ScrollZoomText from './Components/Pages/scrollZoomText';
import AppDashboard from './Components/Dashboard/Dashboardpage';
import Appsidebar from './Components/Appsidebar';
import StakingHistory from './Components/Dashboard/StakingHistory';
import Mobileappsidebar from './Components/Mobileappsidebar';
import Forgotpassword from './Components/Auth/Forgotpassword';
import Changepassword from './Components/Auth/Changepassword';
import Profile from './Components/Dashboard/Profile';
// import Profilechangepassword from "./Components/Dashboard/Profilechangepassword";
import Profilechangepassword from './Components/Dashboard/Profilechangepassword';
import Mailverification from './Components/Auth/Signup/verifyUser';
import SEO from './seo';

function App() {
  return (
    <>
      <BrowserRouter>
        <SEO />
        <Routes>
          <Route path={`${config.Exchange}`} element={<Home2 />} />
          <Route path={`${config.Exchange}aboutus`} element={<Aboutus />} />
          <Route path={`${config.Exchange}contactus`} element={<Contactus />} />
          <Route
            path={`${config.Exchange}privacypolicy`}
            element={<Privacypolicy />}
          />
          <Route path={`${config.Exchange}faq`} element={<Faq />} />

          <Route
            path={`${config.Exchange}about`}
            element={<h1>Welcome to about page</h1>}
          />

          {/* -------Presale live Starts----------- */}

          {/* <Route path={`${config.baseurl}`} element={<Presale />} /> */}
          <Route path={`${config.baseurl}`} element={<Home2 />} />
          {/* <Route path={`${config.baseurl}home`} element={<Home2 />} /> */}

          <Route
            path={`${config.baseurl}presalesecond`}
            element={<Presalesecond />}
          />
          <Route path={`${config.baseurl}login`} element={<UserLogin />} />
          <Route path={`${config.baseurl}signup`} element={<UserSignup />} />
          <Route
            path={`${config.baseurl}verifyemail`}
            element={<Mailverification />}
          />
          <Route
            path={`${config.baseurl}forgotpassword`}
            element={<Forgotpassword />}
          />
          <Route
            path={`${config.baseurl}changepassword`}
            element={<Changepassword />}
          />

          <Route
            path={`${config.baseurl}emailconfirmation`}
            element={<Emailconfirmation />}
          />
          <Route
            path={`${config.baseurl}walletform`}
            element={<Walletform />}
          />
          <Route
            path={`${config.baseurl}selectwalletform`}
            element={<Selectwalletform />}
          />
          <Route
            path={`${config.baseurl}scanwallet`}
            element={<Scanwallet />}
          />
          <Route path={`${config.baseurl}dashboard`} element={<Dashboard />} />
          <Route
            path={`${config.baseurl}appsidebar`}
            element={<Appsidebar />}
          />
          <Route
            path={`${config.baseurl}mobileappsidebar`}
            element={<Mobileappsidebar />}
          />

          {/* ---------Main Dashboard--------- */}
          <Route
            path={`${config.LaunchApp}dashboard`}
            element={<AppDashboard />}
          />
          <Route path={`${config.LaunchApp}`} element={<AppDashboard />} />
          <Route path={`${config.LaunchApp}swap`} element={<Swap />} />
          {/* <Route path={`${config.LaunchApp}liquiditypool`} element={<Liquiditypool />} /> */}
          {/* <Route path={`${config.LaunchApp}addliquidity`} element={<Addliquidity />} /> */}
          {/* <Route path={`${config.LaunchApp}removeliquidity`} element={<Removeliquidity />} /> */}
          <Route
            path={`${config.LaunchApp}simplestaking`}
            element={<Simplestaking />}
          />
          {/* <Route
            path={`${config.LaunchApp}transactionhistory`}
            element={<TransactionHistory />}
          /> */}
          {/* <Route
            path={`${config.LaunchApp}stakinghistory`}
            element={<StakingHistory />}
          /> */}
          <Route path={`${config.LaunchApp}profile`} element={<Profile />} />
          <Route
            path={`${config.LaunchApp}profilechangepassword`}
            element={<Profilechangepassword />}
          />

          <Route
            path={`${config.baseurl}scrollZoomText`}
            element={<ScrollZoomText />}
          />

          <Route path={`/*`} element={<PageNotFound />} />
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;
